import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductTyreResource } from '@data/product-tyres/product-tyres.model';

@Component({
  selector: 'app-tyre-size',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tyre-size.component.html',
  styleUrls: ['./tyre-size.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TyreSizeComponent {
  @Input() tyre: ProductTyreResource;
}
